import { scrollToId } from "@/lib/motion";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-ink-2">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-sm bg-acid" />
              <span className="font-display font-extrabold text-2xl text-paper">AXIOM</span>
            </div>
            <p className="mt-4 max-w-xs text-paper/45 leading-relaxed">
              The revenue operating system for teams that would rather know than guess.
            </p>
          </div>

          <button
            data-testid="footer-book-demo"
            onClick={() => scrollToId("book")}
            className="group flex items-center gap-2 font-display font-bold text-3xl md:text-5xl text-paper hover:text-acid transition-colors"
          >
            Book a demo
            <ArrowUpRight className="w-8 h-8 md:w-12 md:h-12 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/40">
          <span>© {new Date().getFullYear()} AXIOM Labs</span>
          <span>Built for revenue teams · SOC2 · GDPR</span>
        </div>
      </div>
    </footer>
  );
};
